import {AnnouncementItems} from '../consts/types';

export const checkIsWelcome = (announcement: AnnouncementItems) => {
    return announcement.type === 'Welcome';
};

export const getWelcomePage = (announcements: AnnouncementItems[]) => {
    if (checkIsWelcome(announcements[0])) {
        return announcements[0];
    }
    return null;
};

export const getAnnouncements = (announcements: AnnouncementItems[]) => {
    if (checkIsWelcome(announcements[0])) {
        return announcements.slice(1);
    }
    return announcements;
};
